"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ONE_MINUTE = exports.ONE_HOUR = exports.THIRTY_MINUTES_MILLIS = exports.FIFTEEN_MINUTES_MILLIS = exports.ONE_HOUR_MILLIS = exports.ONE_MINUTE_MILLIS = void 0;
exports.ONE_MINUTE_MILLIS = 1000 * 60;
exports.ONE_HOUR_MILLIS = 1000 * 60 * 60;
exports.FIFTEEN_MINUTES_MILLIS = 15 * 60 * 1000;
exports.THIRTY_MINUTES_MILLIS = 30 * 60 * 1000;
exports.ONE_HOUR = 3600;
exports.ONE_MINUTE = 60;
